import gql from 'graphql-tag';

export default gql`
  mutation TEAM_REGISTRATION_CREATE($teamRegistration: TeamRegistrationInput!) {
    teamRegistrationCreate(teamRegistration: $teamRegistration) {
      id
    }
  }
`
